import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgBarChart06 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 8v13m12-4v4M3 3v18m12-8v8"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBarChart06)
export default ForwardRef
